<script lang="ts">
	import { Config } from '#lib/constants/config.js';
</script>

<svelte:head>
	<link rel="preconnect" href="https://www.google.com" />
	<link
		rel="preconnect"
		href="https://www.gstatic.com"
		crossorigin="anonymous"
	/>

	<!-- Async so it no longer blocks rendering. Nothing runs reCAPTCHA at load:
		every caller goes through grecaptcha.ready() at submit time, or polls for
		grecaptcha (toggleRecaptchaBadge), and falls back when it is absent —
		the same path a client-side navigation already took, where this tag is
		injected and so loads async anyway. -->
	<script
		async
		defer
		src={`https://www.google.com/recaptcha/api.js?render=${Config.RecaptchaKey}`}
	></script>
</svelte:head>
